<template>
  <div>
    <SummaryCards v-if="mode === 'all'" :cards="summaryCards" :col-props="{cols: 12, sm: 6, md: 4}"/>
    <div :class="mode === 'all' ? 'white elevation-2 rounded' : ''">
    <div v-if="mode === 'all'">
      <v-row class="my-0" align="center">
        <v-col class="py-0">
          <v-tabs v-model="tab" @change="updateRouteHash(tab)" background-color="transparent" class="grey--text text--lighten-1">
            <v-tab :ripple="false" href="#booked" :disabled="loading" class="text-none">
              {{ 'booked'|localize }}
            </v-tab>
            <v-tab :ripple="false" href="#all" :disabled="loading" class="text-none">
              {{ 'all_quotes'|localize }}
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="auto" class="py-0">
          <v-btn text color="primary" @click="resetFilters();clearOffers();getOffers()" class="mr-2"><v-icon left>mdi-sync</v-icon> {{ 'resetFilters'|localize }}</v-btn>
        </v-col>
      </v-row>
      <v-divider class="mb-1"/>
      <v-container class="py-0">
        <v-row class="my-0 mb-2">
          <v-col cols="4" class="py-0 pr-1">
            <v-select
              :background-color="filters.company_id.length ? 'serenade' : ''"
              v-model="filters.company_id"
              :items="companies"
              :loading="companiesLoading"
              :disabled="companiesLoading"
              item-text="title"
              item-value="id"
              dense
              hide-details
              outlined
              clearable
              multiple
              :placeholder="'transportCompany'|localize"
              @change="clearOffers();getOffers();"
            >
              <template v-slot:item="{ item }">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate mr-1" style="max-width: 100px">{{ item.title }}</span>
                <span v-if="index === 1" class="grey--text text-caption mr-1">+{{ filters.company_id.length - 1 }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0 px-1">
            <v-select
              :background-color="filters.transport_mode.length ? 'serenade' : ''"
              v-model="filters.transport_mode"
              :items="transportModeList"
              item-text="name"
              item-value="value"
              dense
              hide-details
              outlined
              clearable
              multiple
              :placeholder="'transportMode'|localize"
              @change="clearOffers();getOffers();"
            >
              <template v-slot:item="{ item }">
                <v-icon class="mr-2" color="silver-chalice">{{ TRANSPORT_ICONS[item['value']] }}</v-icon>
                <v-list-item-title>{{ item.value|localize }}</v-list-item-title>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-icon v-if="index <= 2" class="mr-2" color="silver-chalice">{{ TRANSPORT_ICONS[item['value']] }}</v-icon>
                <span v-if="index === 3" class="grey--text text-caption">+{{ filters.transport_mode.length - 3 }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0 pl-1">
            <v-select
              :background-color="filters.request_type && 'serenade'"
              v-model="filters.request_type"
              :items="requestTypesList"
              item-text="name"
              item-value="value"
              dense
              hide-details
              outlined
              clearable
              :placeholder="'requestType'|localize"
              @change="clearOffers();getOffers();"
            />
          </v-col>
        </v-row>
        <v-row class="my-0 mb-2">
          <v-col cols="4" class="py-0 pr-1">
            <v-select
              :background-color="filters.currency.length ? 'serenade' : ''"
              v-model="filters.currency"
              :items="CURRENCIES"
              dense
              hide-details
              outlined
              clearable
              multiple
              :placeholder="'currency'|localize"
              @change="clearOffers();getOffers();"
            >
              <template v-slot:item="{ item }">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate mr-1" style="max-width: 100px">{{ item }}</span>
                <span v-if="index === 1" class="grey--text text-caption mr-1">+{{ filters.currency.length - 1 }}</span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="4" class="py-0 px-1">
            <v-menu
              ref="menuDate"
              v-model="menuDate"
              :close-on-content-click="false"
              :return-value.sync="filters.date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :background-color="filters.date.length ? 'serenade' : ''"
                  :placeholder="'dateCreated' | localize"
                  :value="dateRangeText"
                  readonly
                  dense
                  hide-details
                  outlined
                  clearable
                  v-on="on"
                  @click:clear="clearOffers();filters.date = [];getOffers()"
                />
              </template>
              <v-date-picker
                v-model="filters.date"
                no-title
                scrollable
                range
                @input="filters.date.length === 2 && $refs.menuDate.save(filters.date)"
                @change="clearOffers();getOffers();"
              />
            </v-menu>
          </v-col>
          <v-col v-if="tab === 'all'" cols="4" class="py-0 pl-1">
            <v-select
              :background-color="filters.status.length ? 'serenade' : ''"
              v-model="filters.status"
              :items="proposalStatusesList"
              item-text="name"
              item-value="value"
              dense
              hide-details
              outlined
              clearable
              multiple
              :placeholder="'status'|localize"
              @change="clearOffers();getOffers();"
            >
              <template v-slot:item="{ item }">
                <v-icon :color="STATUS_COLORS[item.value]" size="20" class="mr-2">{{ STATUS_ICONS[item.value] }}</v-icon>
                <v-list-item-title>{{ item.value|localize }}</v-list-item-title>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-icon v-if="index <= 2" :color="STATUS_COLORS[item.value]" size="20" class="mr-2">{{ STATUS_ICONS[item.value] }}</v-icon>
                <span v-if="index === 3" class="grey--text text-caption">+{{ filters.status.length - 3 }}</span>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row v-if="tab === 'all'" class="my-0 mb-2">
          <v-col cols="4" class="py-0 pr-1">
            <v-switch v-model="filters.expiring_soon" dense hide-details class="ma-0" :label="'quotesExpiringSoon'|localize" @change="clearOffers();getOffers();"/>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-data-table
      :headers="headers"
      :items="offers"
      :loading="loading"
      loader-height="2"
      :sort-by="defaultSortBy"
      :sort-desc="defaultSortDesc"
      :options.sync="options"
      :server-items-length="totalItems"
      hide-default-footer
    >
      <template v-slot:no-data>
        <EmptyState :icon="emptyState.icon" :title="emptyState.title|localize" :subtitle="emptyState.subtitle|localize">
          <v-btn v-if="mode === 'all' && isFiltered" text color="primary" @click="resetFilters();clearOffers();getOffers()">
            <v-icon left>mdi-sync</v-icon>{{ 'resetFilters'|localize }}
          </v-btn>
        </EmptyState>
      </template>
      <template v-slot:item.request_id="{ item }">
        <router-link v-if="item.request_id" class="black--text" style="vertical-align: middle" :to="{name: 'admin-request-details', query: {request_id: item.request_id}}" target="_blank">{{ item.request_id }}</router-link>
      </template>
      <template v-slot:item.date_proposal="{ item }">
        <div>{{ item.date_proposal }}</div>
        <div class="mt-1 smart-quote-badge-slot">
          <v-chip v-if="isSmartQuote(item)" x-small color="light-blue lighten-5" text-color="light-blue darken-2" class="smart-quote-badge">
            <v-icon left size="12" color="light-blue darken-2">mdi-creation</v-icon>{{ 'smartQuoteBadge'|localize }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.company="{ item }">
        <v-tooltip right color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <router-link v-if="item.company_id" class="black--text" :to="{name: 'create-company', query: {company_id: item.company_id}}" target="_blank">{{ item.company }}</router-link>
              <template v-else>{{ item.company }}</template>
            </span>
          </template>
          <div v-if='item.extra_emails'>
            <div><strong>{{ 'from'|localize }}: </strong>{{ item.extra_emails.from || '--' }}</div>
            <div><strong>{{ 'booking'|localize }}: </strong>{{ item.extra_emails.booking || '--' }}</div>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.lead_time="{ item }">
        {{ item['lead_time'] }} {{ leadTimeDays(item['lead_time']) }}
      </template>
      <template v-slot:item.emissions="{ item }">
        {{ item['emissions'] ? item['emissions'] : '--' }}
      </template>
      <template v-slot:item.valid_to="{ item }">
        <div v-html="$options.filters.formatDate(item['valid_to'])"/>
      </template>
      <template v-slot:item.transport_mode_shortcode="{ item }">
        <v-tooltip top color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="ml-7" v-bind="attrs" v-on="on" color="silver-chalice">
              {{ TRANSPORT_ICONS[item['transport_mode_shortcode']] }}
            </v-icon>
          </template>
          <span>{{ item['transport_mode_shortcode']|localize }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.comment="{ item }">
        <v-tooltip v-if="item.comment" top color="black" max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <span class="copy-to-clipboard">
              <v-icon v-bind="attrs" color="success" v-on="on" size="20">mdi-comment</v-icon>
              <span class="d-none">{{ item.comment }}</span>
            </span>
          </template>
          <span>{{ item.comment }}<br><small>{{ 'clickToCopy'|localize }}</small></span>
        </v-tooltip>
        <v-tooltip v-if="item['reopen_comment']" top color="black" max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <span class="copy-to-clipboard">
              <v-icon v-bind="attrs" v-on="on" color="warning" size="20">mdi-comment</v-icon>
              <span class="d-none">{{ item['reopen_comment'] }}</span>
            </span>
          </template>
          <div>
            <div class="mb-2"><strong>{{ 'reopenComment'|localize }}:</strong></div>
            {{ item['reopen_comment'] }}<br><small>{{ 'clickToCopy'|localize }}</small>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.attachments="{ item }">
        <v-tooltip v-for="fileData in item['attachments']" :key="fileData['attachment_name']" top color="black" max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <a :href="fileData['attachment_link']" target="_blank" style="text-decoration: none">
              <v-icon v-bind="attrs" color="success" v-on="on" size="20">mdi-file</v-icon>
            </a>
          </template>
          <span>{{ fileData['attachment_name'] }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-btn
          v-if="item.status === STATUSES.BOOKED"
          class="justify-center text-subtitle-2"
          rounded
          fab
          x-small
          depressed
          color="success"
          :to="{name: 'booking-summary', query: {request_id: item.request_id || requestId, proposal_id: item.id}}"
        >
          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" size="20">mdi-book-open-variant</v-icon>
            </template>
            <span>{{ 'bookingSummaryOpen'|localize }}</span>
          </v-tooltip>
        </v-btn>
        <div v-else class="d-flex align-center justify-center">
          <v-icon :color="STATUS_COLORS[item.status]" size="20" class="mr-2">{{ STATUS_ICONS[item.status] }}</v-icon>
          <span>{{ item.status|localize }}</span>
        </div>
      </template>
      <template v-slot:item.settings="{ item }">
        <v-menu v-if="allowedStatuses(item.status) || item.status === STATUSES.BOOKED || isSmartQuote(item)" left transition="slide-y-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon :ripple="false">
              <v-icon size="20">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="item.status === STATUSES.EXPIRED" link @click="$refs.reopenDialog.openDialog(); reopenId = item.id">
              <v-list-item-title>{{ 'reopen'|localize }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="item.status === STATUSES.EXPIRED || item.status === STATUSES.NOT_BOOKED" link :to="{name: 'booking', query: {offer_id: item.id, request_id: item.request_id || requestId, mode: item['transport_mode_shortcode']}}">
              <v-list-item-title>{{ 'book'|localize }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="allowedStatuses(item.status)" link @click="openQuickBookDialog(item)">
              <v-list-item-title>{{ 'quickBook'|localize }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="item.status === STATUSES.BOOKED" link @click="openCancelBookingDialog(item)">
              <v-list-item-title>{{ 'cancelBooking'|localize }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isSmartQuote(item)" link @click="openAuditTrail(item)">
              <v-list-item-title>{{ 'smartQuoteAuditTrail'|localize }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-pagination
      color="primary"
      v-model="currentPage"
      :length="totalPages"
      :total-visible="7"
      class="py-4"
      :disabled="loading"
      @input="offers = [];getOffers();"
    />
    <ReopenDialog :offerId="reopenId" @updateOffers="getOffers" ref="reopenDialog"/>
    <SimpleDialog
      ref="quickBookDialog"
      :title="'quickBook'|localize"
      :text="'quickBookText'|localize"
      :accept-text="'book'|localize"
      :decline-text="'back'|localize"
      @accept="confirmQuickBook"
    />
    <SimpleDialog
      ref="cancelBookingDialog"
      :title="'cancelBooking'|localize"
      :text="'cancelBookingText'|localize"
      :accept-text="'cancelBooking'|localize"
      :decline-text="'back'|localize"
      @accept="confirmCancelBooking"
    />
    <SmartQuoteAuditTrailDrawer ref="auditTrailDrawer" />
    </div>
  </div>
</template>

<script>
  import {TRANSPORT_ICONS} from '@/enums/transportMode';
  import {STATUSES, STATUS_COLORS, STATUS_ICONS} from '@/enums/statuses';
  import {CURRENCIES} from '@/enums/currency';
  import localize from '@/filters/localize';
  import api from '@/api/api';
  import ReopenDialog from '@/components/ReopenDialog.vue';
  import SimpleDialog from '@/components/common/SimpleDialog';
  import EmptyState from '@/components/common/EmptyState';
  import SummaryCards from '@/components/common/SummaryCards';
  import filterRouteSync from '@/mixins/filterRouteSync';
  import SmartQuoteAuditTrailDrawer from '@/components/SmartQuoteAuditTrailDrawer.vue';

  // Empty-state copy per tab (mode="all" only), shown when a tab genuinely has no rows.
  const EMPTY_STATE_BY_TAB = {
    booked: {icon: 'mdi-calendar-check-outline', title: 'emptyAdmQuoteBookedTitle', subtitle: 'emptyAdmQuoteBookedSubtitle'},
    all: {icon: 'mdi-file-document-outline', title: 'emptyAdmQuoteAllTitle', subtitle: 'emptyAdmQuoteAllSubtitle'},
  };

  export default {
    name: "AdminQuotes",
    components: { ReopenDialog, SimpleDialog, EmptyState, SummaryCards, SmartQuoteAuditTrailDrawer },
    // `initialHash` and `handleFiltersQuery` below intentionally override the mixin's versions:
    // this component has a `mode` prop ('single' vs 'all') that the shared logic doesn't know about.
    mixins: [filterRouteSync],

    props: {
      mode: {
        type: String,
        default: 'single',
        validator: (value) => ['single', 'all'].includes(value),
      },
    },

    data() {
      return {
        TRANSPORT_ICONS,
        STATUSES,
        STATUS_COLORS,
        STATUS_ICONS,
        CURRENCIES,
        requestId: this.$router.currentRoute.query.request_id,
        loading: true,
        defaultSortBy: 'date_proposal',
        defaultSortDesc: true,
        options: {},
        itemsPerPage: 20,
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        offers: [],
        reopenId: null,
        quickBookOfferId: null,
        cancelBookingOfferId: null,
        tab: this.initialHash(),
        // Set by goToTab() right before it changes `tab` on behalf of a summary card, so the `tab`
        // watcher below skips its own reset+fetch (goToTab already did it, with the patch applied).
        suppressTabWatch: false,
        menuDate: false,
        companies: [],
        companiesLoading: false,
        filters: this.initialFilters(),
        summary: {
          without_relevant_tc: 0,
          closing_soon: 0,
          action_required: 0,
          quotes_expiring_soon: 0,
          need_response: 0,
        },
        smartQuoteMap: {},
      };
    },

    created() {
      this.loadSmartQuoteMap();
    },

    watch: {
      options: {
        handler() {
          this.clearOffers();
          this.getOffers();
        },
        deep: true,
      },
      tab() {
        if (this.suppressTabWatch) {
          this.suppressTabWatch = false;
          return;
        }
        this.resetFilters();
        this.clearOffers();
        this.getOffers();
      },
      filters: {
        handler() {
          this.handleFiltersQuery();
        },
        deep: true,
      },
    },

    mounted() {
      if (this.mode === 'all') {
        this.getCompanies();
        this.getRequestsSummary();
      }
    },

    computed: {
      // Same "what needs attention" row as the admin requests dashboard, so the blocks stay in view
      // when a quote card hands the admin off to this page. Request cards jump back to admin-requests;
      // the two quote cards (action-required / expiring) filter this offers list in place.
      summaryCards() {
        return [
          {key: 'without_relevant_tc', icon: 'mdi-truck', color: 'warning', count: this.summary.without_relevant_tc, label: localize('requestsWithoutRelevantTc'), actionLabel: localize('view'), onClick: () => this.goToAdminRequests('new', {no_relevant_tc: true})},
          {key: 'closing_soon', icon: 'mdi-clock-alert-outline', color: 'error', count: this.summary.closing_soon, label: localize('requestsClosingSoon'), actionLabel: localize('view'), onClick: () => this.goToAdminRequests('all', {deadline_within_hours: 24})},
          {key: 'action_required', icon: STATUS_ICONS[STATUSES.ACTION_REQUIRED], color: STATUS_COLORS[STATUSES.ACTION_REQUIRED], count: this.summary.action_required, label: localize('action_required'), actionLabel: localize('view'), onClick: () => this.goToTab('all', {status: ['action_required']})},
          {key: 'quotes_expiring_soon', icon: 'mdi-clock-alert-outline', color: 'error', count: this.summary.quotes_expiring_soon, label: localize('quotesExpiringSoon'), actionLabel: localize('view'), onClick: () => this.goToTab('all', {expiring_soon: true})},
          {key: 'need_response', icon: STATUS_ICONS[STATUSES.NEED_RESPONSE], color: STATUS_COLORS[STATUSES.NEED_RESPONSE], count: this.summary.need_response, label: localize('need_response'), actionLabel: localize('view'), onClick: () => this.goToAdminRequests('all', {status: ['need_response']})},
        ];
      },
      allowedStatuses() {
        const allowedStatuses = [STATUSES.EXPIRED, STATUSES.NOT_BOOKED, STATUSES.NEW];
        return (status) => allowedStatuses.includes(status);
      },
      transportModeList() {
        return this.$store.getters.transportModeList;
      },
      requestTypesList() {
        return this.$store.getters.requestTypesList;
      },
      // Proposal statuses (ProposalStatuses on the backend) differ from the store's `statuses`
      // getter, which lists Request statuses and doesn't include `action_required`.
      proposalStatusesList() {
        const proposalStatuses = [
          STATUSES.NEW,
          STATUSES.DRAFT,
          STATUSES.BOOKED,
          STATUSES.NOT_BOOKED,
          STATUSES.REJECTED,
          STATUSES.VIEWED,
          STATUSES.EXPIRED,
          STATUSES.DECLINED,
          STATUSES.ACTION_REQUIRED,
        ];
        return proposalStatuses.map((value) => ({name: localize(value), value}));
      },
      dateRangeText() {
        return this.filters.date.sort().join(' ~ ');
      },
      isFiltered() {
        return Object.values(this.filters).some((value) => Array.isArray(value) ? value.length > 0 : !!value);
      },
      emptyState() {
        if (this.mode === 'single') {
          return {icon: 'mdi-inbox-outline', title: 'emptyGenericTitle', subtitle: 'emptyGenericSubtitle'};
        }
        if (this.isFiltered) {
          return {icon: 'mdi-filter-remove-outline', title: 'emptyFilteredTitle', subtitle: 'emptyFilteredSubtitle'};
        }
        return EMPTY_STATE_BY_TAB[this.tab] || {icon: 'mdi-inbox-outline', title: 'emptyGenericTitle', subtitle: 'emptyGenericSubtitle'};
      },
      headers() {
        const headers = [
          {text: localize('quoteDate'), value: 'date_proposal', width: 140},
        ];
        if (this.mode === 'all') {
          headers.push({text: localize('requestId'), value: 'request_id', width: 110});
        }
        headers.push(
          {text: localize('transportCompany'), value: 'company'},
          {text: localize('offered_price'), value: 'company_price', width: 100, sortable: false},
          {text: localize('client_price'), value: 'proposal', width: 100, sortable: false},
          {text: localize('currency'), value: 'currency', width: 70, sortable: false},
          {text: localize('leadTime'), value: 'lead_time', width: 90},
          {text: localize('emissions') + ', kg', value: 'emissions', width: 90},
          {text: localize('quoteValidTo'), value: 'valid_to', width: 155},
          {text: localize('transportMode'), value: 'transport_mode_shortcode'},
          {text: localize('comments'), value: 'comment', align: 'center', width: 130},
          {text: localize('attachedDocuments'), value: 'attachments'},
          {text: '', value: 'status', align: 'center', width: 170, sortable: false},
          {text: '', value: 'settings', sortable: false, align: 'center'},
        );
        return headers;
      }
    },

    methods: {
      clearOffers() {
        this.offers = [];
        this.totalPages = 0;
        this.totalItems = 0;
        this.currentPage = 1;
      },
      leadTimeDays(item) {
        return item > 1 ? localize('days') : localize('day')
      },
      async loadSmartQuoteMap() {
        try {
          let response = await api.getSmartQuoteProposalMap();
          this.smartQuoteMap = (response.data && response.data.items) || {};
        } catch (e) {
          // Non-blocking — the quotes list still works without the Smart Quote badge.
        }
      },
      isSmartQuote(item) {
        return !!this.smartQuoteMap[item.id];
      },
      openAuditTrail(item) {
        this.$refs.auditTrailDrawer.open(item.id);
      },
      queryData() {
        let queryData = {};
        if (this.mode === 'single') {
          queryData.request_id = this.requestId;
        } else {
          queryData.tab = this.tab;
        }
        queryData.per_page = this.itemsPerPage;
        queryData.page = this.currentPage;
        this.options.sortBy[0] && (
          queryData['sort'] = {
            field: this.options.sortBy[0],
            desc: this.options.sortDesc[0],
          });
        if (this.mode === 'all') {
          queryData.filters = {};
          this.filters.company_id.length && (queryData.filters.company_id = this.filters.company_id);
          this.filters.transport_mode.length && (queryData.filters.transport_mode = this.filters.transport_mode);
          this.filters.request_type && (queryData.filters.request_type = [this.filters.request_type]);
          this.filters.currency.length && (queryData.filters.currency = this.filters.currency);
          this.filters.status.length && (queryData.filters.status = this.filters.status);
          this.filters.date.length && (queryData.filters.date = this.filters.date.sort());
          this.filters.expiring_soon && (queryData.filters.expiring_soon = this.filters.expiring_soon);
        }
        return queryData;
      },
      resetFilters() {
        this.filters.company_id = [];
        this.filters.transport_mode = [];
        this.filters.request_type = null;
        this.filters.currency = [];
        this.filters.status = [];
        this.filters.date = [];
        this.filters.expiring_soon = false;
      },
      async getRequestsSummary() {
        try {
          const summaryData = await api.getAdminRequestsSummary();
          this.summary = summaryData.data;
        } catch (e) {}
      },
      // Quote cards filter this offers list in place; suppress the tab watcher's own reset+fetch so
      // the card's filter patch survives, then fetch once and sync the tab + filter into the URL.
      goToTab(tab, filterPatch = {}) {
        const tabChanged = this.tab !== tab;
        if (tabChanged) {
          this.suppressTabWatch = true;
        }
        // Always reset filters first, so a second summary card targeting the same tab replaces the
        // previous card's filter instead of stacking on top of it.
        this.resetFilters();
        this.tab = tab;
        Object.assign(this.filters, filterPatch);
        this.clearOffers();
        this.getOffers();
        this.updateRouteHash(tab);
      },
      // Request cards live on the admin-requests page; hand off there with the tab + filter preset.
      goToAdminRequests(hash, filterPatch = {}) {
        this.$router.push({name: 'admin-requests', hash: `#${hash}`, query: {filters: this.filtersQuery(filterPatch)}});
      },
      initialHash() {
        if (this.mode !== 'all') return 'booked';
        const queryHash = this.$router.currentRoute.hash.slice(1);
        return queryHash ? queryHash : 'booked';
      },
      initialFilters() {
        const defaultFilters = {
          company_id: [],
          transport_mode: [],
          request_type: null,
          currency: [],
          status: [],
          date: [],
          expiring_soon: false,
        };
        if (this.mode !== 'all') return defaultFilters;
        const queryFilters = this.$router.currentRoute.query?.filters;
        if (queryFilters && typeof queryFilters === 'string') {
          try {
            // Merge over defaults so keys missing from a stale/partial URL stay present and reactive (Vue 2).
            return {...defaultFilters, ...JSON.parse(queryFilters)};
          } catch (e) {
            // A malformed filters query must not crash the page; fall back to defaults.
            return defaultFilters;
          }
        }
        return defaultFilters;
      },
      handleFiltersQuery() {
        if (this.mode !== 'all') return;
        const desired = this.filtersQuery(this.filters);
        if ((this.$route.query.filters || undefined) !== desired) {
          this.$router.replace({...this.$route, query: {...this.$route.query, filters: desired}});
        }
      },
      async getCompanies() {
        try {
          this.companiesLoading = true;
          let companiesData = await api.getAdminCompanies({per_page: 1000, page: 1});
          this.companies = companiesData.data?.data || [];
        } catch (e) {
        } finally {
          this.companiesLoading = false;
        }
      },
      setOffersData(requestsData) {
        this.offers = requestsData.data.data;
        this.totalPages = requestsData.data.pagination['total_page'];
        this.totalItems = requestsData.data.pagination['total_items'];
      },
      async getOffers() {
        try {
          this.loading = true;
          let requestsData = this.mode === 'single'
            ? await api.getRequestOffers(this.queryData()) 
            : await api.getAllOffers(this.queryData());
          this.setOffersData(requestsData);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      },
      async quickBookOffer() {
        try {
          this.loading = true;
          await api.quickBookOffer(this.quickBookOfferId);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      },
      openQuickBookDialog(item) {
        this.quickBookOfferId = item.id;
        this.$refs.quickBookDialog.open();
      },
      async confirmQuickBook() {
        await this.quickBookOffer();
        this.quickBookOfferId = null;
        this.$refs.quickBookDialog.close();
        await this.getOffers();
      },
      async cancelBookingOffer() {
        try {
          this.loading = true;
          await api.cancelBookingOffer(this.cancelBookingOfferId);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      },
      openCancelBookingDialog(item) {
        this.cancelBookingOfferId = item.id;
        this.$refs.cancelBookingDialog.open();
      },
      async confirmCancelBooking() {
        await this.cancelBookingOffer();
        this.cancelBookingOfferId = null;
        this.$refs.cancelBookingDialog.close();
        await this.getOffers();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .smart-quote-badge-slot {
    height: 20px;
    line-height: 20px;
  }
</style>
